module.exports = __webpack_public_path__ + "img/detBannerBlue.f468f59a.jpg";